import { Component, inject, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { GenericProjectStore } from '@app/stores/projects/generic-project.store';
import { ValidatedDatePickerComponent } from '@app/ui-components/validated-date-picker/validated-date-picker.component';
import { ValidatedDropdownComponent } from '@app/ui-components/validated-dropdown/validated-dropdown.component';
import { ValidatedNumberInputComponent } from '@app/ui-components/validated-number-input/validated-number-input.component';
import { TranslateModule } from '@ngx-translate/core';
import { FinancialAssetFormGroup } from './device-card-form.helper';

@Component({
  selector: 'app-device-card',
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    ValidatedDatePickerComponent,
    ValidatedDropdownComponent,
    ValidatedNumberInputComponent,
  ],
  templateUrl: './device-card.component.html',
  styleUrl: './device-card.component.scss',
})
export class DeviceCardComponent {
  formGroup = input.required<FormGroup<FinancialAssetFormGroup>>();
  disabled = input<boolean>(false);
  protected genericProjectStore = inject(GenericProjectStore);
  protected translationKey = 'instrumentForm.';
}
